import { useQuery } from '@apollo/client'
import { useRouter } from 'next/router'
import React, { FC, createContext } from 'react'
import { getJournalSectionsVariables } from '../lib/gql'
import { JOURNAL_ITEMS, JOURNAL_SECTIONS } from '../queries/journalQuery'
import { SortOrder } from '../__generated__/globalTypes'
import {
  journalItems,
  journalItemsVariables,
  journalItems_elements_edges_node,
} from '../__generated__/journalItems'
import {
  journalSections,
  journalSectionsVariables,
  journalSections_sections_nodes,
} from '../__generated__/journalSections'

interface IArticleContext {
  more: journalItems_elements_edges_node[]
  section: string
  code: string
  sections: journalSections_sections_nodes[]
}

export const ArticleContext = createContext({} as IArticleContext)

interface IArticleProvider {
  section: string
  code: string
  today: string
}

const ArticleProvider: FC<IArticleProvider> = ({
  children,
  section,
  code,
  today,
}) => {
  const { query } = useRouter()

  const { data } = useQuery<journalItems, journalItemsVariables>(
    JOURNAL_ITEMS,
    {
      variables: {
        where: {
          iblock: {
            code: {
              equals: 'articles',
            },
          },
          active: { equals: true },
          sections: { some: { code: { equals: section } } },
          OR: [
            {
              activeFrom: { lte: today },
              activeTo: { equals: null },
            },
            {
              activeFrom: { lte: today },
              activeTo: { gte: today },
            },
            {
              activeFrom: { equals: null },
              activeTo: { equals: null },
            },
            {
              activeFrom: { equals: null },
              activeTo: { gte: today },
            },
          ],
        },
        order: { activeFrom: SortOrder.desc },
        first: 4,
      },
    },
  )

  const { data: seсtionsData } = useQuery<
    journalSections,
    journalSectionsVariables
  >(JOURNAL_SECTIONS, { variables: getJournalSectionsVariables() })

  const more = data?.elements?.edges
    ?.filter((edge) => edge.node.code !== query?.code)
    ?.slice(0, 3)
    ?.map((edge) => edge?.node)
  const sections = seсtionsData?.sections?.nodes
  return (
    <ArticleContext.Provider value={{ more, section, sections, code }}>
      {children}
    </ArticleContext.Provider>
  )
}

export default ArticleProvider
